import React from "react";
import { Card, Typography, Divider, Form, Row, Col } from "antd";
import Description from "./General/Description";
import AddressForm from "./Address/Form";
import Contact from "./General/Contact";
import Gallery from "./General/Gallery";
import metaData from "../data/metaData";
import SectionHeader from "./GetStarted/SectionHeader";
import Name from "./General/Name";
import LogoUploader from "./General/LogoUploader";
import ShopLogo from "./Shop/Logo";

const { Title, Paragraph, Text } = Typography;

const ShopProfile = ({ state = {}, brand, readOnly = true }) => {
  const { data, form, onChange } = state;

  return (
    <Card
      title={<SectionHeader title="Shop" />}
      style={{
        ...cardStyle,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Display the logo if brand is available */}
      {readOnly ? (
        <ShopLogo
          style={{ width: "5rem", height: "5rem", objectFit: "cover", marginRight: "0.5rem" }}
          logo={data?.logo}
          brandLogo={data?.brand?.logo}
        />
      ) : (
        <LogoUploader logo={data?.logo || brand?.logo || null} onFinish={onChange} readOnly={readOnly} />
      )}

      {/* Shop Name - Editable or Static */}
      {readOnly ? (
        <Title level={4}>{data?.name}</Title>
      ) : (
        <Name
          state={{
            data: data?.name,
            form: form,
            rules: [{ required: true, message: "required" }],
            onChange: onChange,
          }}
          readOnly={readOnly}
          maxLength={60}
          showCount
        />
      )}

      <Row style={{ width: "100%" }}>
        <Col>
          <Text type="secondary" style={{ marginRight: "2rem" }}>
            ID
          </Text>
        </Col>
        <Col>
          <Text>{data?.id}</Text>
        </Col>
      </Row>

      {/* Description */}
      <Title level={5}>Description</Title>
      <Description
        state={{
          data: data?.description,
          form: form,
          onChange: onChange,
          keyName: "description",
        }}
        readOnly={readOnly}
        placeholder={"A brief description of your shop"}
      />

      {/* Open Hour - Only show in editable mode */}
      {!readOnly && (
        <>
          <Title level={5}>Open Hour</Title>
          <Paragraph
            type="secondary"
            ellipsis={{ rows: 2, expandable: true, symbol: "see example" }}
            style={{ whiteSpace: "pre-wrap" }}
          >
            {`Example: 
Mon: 9 AM - 1 PM | 3 PM - 8 PM
Tue: 9 AM - 1 PM | 3 PM - 8 PM
Wed: 9 AM - 1 PM | 3 PM - 8 PM
Thu: 9 AM - 1 PM | 3 PM - 8 PM
Fri: 9 AM - 1 PM | 3 PM - 8 PM
Sat: 9 AM - 8 PM
Sun: 9 AM - 8 PM`}
          </Paragraph>
          <Description
            state={{
              data: data?.openHour,
              form: form,
              onChange: onChange,
              keyName: "openHour",
            }}
            readOnly={readOnly}
            placeholder={"Open hour of your shop"}
          />
        </>
      )}

      <Divider style={{ background: "var(--ion-color-step-200)", height: "2px", margin: "3rem 0" }} />

      {/* Shop Address */}
      <Title level={5}>Shop Address</Title>
      <AddressForm state={{ data: data?.address, form: form, onChange: onChange }} readOnly={readOnly} />

      <Divider style={{ background: "var(--ion-color-step-200)", height: "2px", margin: "3rem 0" }} />

      {/* Contact Information */}
      <Title level={5}>Contact</Title>
      <Contact
        state={{
          phone: data?.phone,
          email: data?.email,
          website: data?.website,
          form: form,
          onChange: onChange,
        }}
        readOnly={readOnly}
      />

      <Divider style={{ background: "var(--ion-color-step-200)", height: "2px", margin: "3rem 0" }} />

      {/* Gallery */}
      <Title level={5}>Gallery</Title>
      {!readOnly && (
        <Row style={{ marginBottom: "2rem" }}>
          <Text type="secondary">
            Max 4 photos. 16:9, JPG or PNG. Max size of 5MB, You can delete or change the order of the photos.
          </Text>
        </Row>
      )}
      <Gallery
        state={{
          data: data?.gallery,
          onChange: onChange,
        }}
        aspect={16 / 9}
        readOnly={readOnly}
        width={"100%"}
      />
    </Card>
  );
};

const cardStyle = {
  border: "2px solid var(--ion-color-step-150)",
};

export default ShopProfile;
